import React, { Component } from 'react';
import {
    Navbar,
    Nav,
    NavbarBrand,
    NavbarText,
    Dropdown,
    DropdownMenu,
    DropdownToggle,
    DropdownItem
} from 'reactstrap';

import Utils from "../../Utils";
import './NavMenu.css';

export class NavMenu extends Component {
    static displayName = NavMenu.name;

    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);

        this.state = {
            collapsed: true,
            profiledata: null,
            userInfo: { roles: "P" },
            userMenuOpen: false
        };

        this.getProfileData();
        setTimeout(() => this.getUserInfo(), 800);
    }

    toggleNavbar() {
        this.setState(prev => ({
            collapsed: !prev.collapsed
        }));
    }

    toggleUserMenu = () => {
        this.setState(prev => ({
            userMenuOpen: !prev.userMenuOpen
        }));
    };

    async getProfileData() {
        let profileData = await Utils.getProfileData();

        this.setState({
            profiledata: profileData
        });
    }

    async getUserInfo() {
        await Utils.getUserInfo()
            .then(data => {
                if (data.status === 200) {
                    this.setState({ userInfo: data.data });
                } else {
                    window.location.href = "/.auth/login";
                }

                if (
                    (data.data.roles === 'A' || data.data.roles === 'V') &&
                    (window.location.href !== window.location.origin + "/admin")
                ) {
                    window.location.href = window.location.origin + "/admin";
                }
            });
    }

    async logOut() {
        await Utils.logOut();
    }

    render() {
        return (
            <>
                <Navbar color="dark" container dark expand="md">
                    <NavbarBrand href="/">
                        <img
                            src="/logo-score-proveedores_2.svg"
                            alt="logo-score"
                            width="274px"
                        />
                    </NavbarBrand>

                    <NavbarText id="ultimaActualizacion" style={{ color: "#fff" }} />

                    <Nav className="ml-auto" navbar>

                        {this.state.profiledata && (
                            <Dropdown
                                nav
                                inNavbar
                                isOpen={this.state.userMenuOpen}
                                toggle={this.toggleUserMenu}
                            >
                                <DropdownToggle
                                    nav
                                    tag="span"
                                    className="proveedor-toggle"
                                >
                                    <span className="proveedor-text">
                                        {this.state.profiledata.lastname}{" "}
                                        {this.state.profiledata.name}
                                    </span>

                                    <img
                                        src="/icon-user.svg"
                                        alt="usuario"
                                        width="26px"
                                    />
                                </DropdownToggle>

                                <DropdownMenu right>

                                    {(this.state.userInfo.roles === "A" ||
                                        this.state.userInfo.roles === "V") && (
                                            <DropdownItem>
                                                <a href="/admin">Administrar</a>
                                            </DropdownItem>
                                        )}

                                    <DropdownItem onClick={() => this.logOut()}>
                                        Logout
                                    </DropdownItem>

                                </DropdownMenu>
                            </Dropdown>
                        )}

                        {!this.state.profiledata && (
                            <Dropdown nav inNavbar>
                                <DropdownToggle nav caret>
                                    <a href="/.auth/login" style={{ color: "#fff" }}>
                                        Login
                                    </a>
                                </DropdownToggle>
                            </Dropdown>
                        )}

                    </Nav>
                </Navbar>

                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "#0d5adb",
                        zIndex: 999999,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >
                    <img
                        src="/performance-mantenimiento.png"
                        alt="Sistema en mantenimiento"
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain"
                        }}
                    />
                </div>

            </>
        );
    }
}